import React from 'react'
import { Col, Container, Form, Modal as BootstrapModal, Row } from 'react-bootstrap'
import { Modal } from '../../../components/Modal/Modal'
import { Controller, useForm } from 'react-hook-form'
import { FormFeedback } from '../../../components/Form/FormFeedback'

export interface UpdatePrivateMeetingsSettingModalProps {
  show: boolean
  onConfirm: (changePastMeetings: boolean) => void
  onCancel: () => void
}

type UpdatePrivateMeetingsSettingFormValues = {
  pastMeetingsAction: 'keep' | 'change'
}

const updatePrivateMeetingsSettingDefaultValues = {
  pastMeetingsAction: 'keep',
}

export const UpdatePrivateMeetingsSettingModal: React.FC<UpdatePrivateMeetingsSettingModalProps> = ({ show, onConfirm, onCancel }) => {
  const { control, getValues, watch } = useForm<UpdatePrivateMeetingsSettingFormValues>({
    defaultValues: updatePrivateMeetingsSettingDefaultValues as UpdatePrivateMeetingsSettingFormValues,
  })
  const pastMeetingsAction = watch('pastMeetingsAction')

  const pageBody = (
    <Container>
      <Row className='m-0'>
        <Col className='p-0'>
          <div className='paragraph-medium mb-3'>
            Turning off private meetings will prevent users from creating new private meetings. What should happen to existing private meetings?
          </div>
          <Controller
            name='pastMeetingsAction'
            control={control}
            render={({ field, fieldState }) => {
              return (
                <>
                  <div>
                    <Form.Check
                      inline
                      type='radio'
                      className='pb-2'
                      label='Keep existing private meetings as they are'
                      id='keep'
                      {...field}
                      value='keep'
                      checked={field.value === 'keep'}
                    />
                    <Form.Check
                      inline
                      type='radio'
                      label='Change all existing private meetings to public'
                      id='change'
                      {...field}
                      value='change'
                      checked={field.value === 'change'}
                    />
                  </div>
                  {fieldState.error && <FormFeedback>{fieldState.error.message}</FormFeedback>}
                </>
              )
            }}
          />
        </Col>
      </Row>
      {pastMeetingsAction === 'keep' ? (
        <Row className='m-0 py-3'>
          <Col className='p-0'>
            <div className='zocks-bg-color-gray-200 rounded p-3'>
              <div className='d-flex align-self-center gap-3 align-items-center'>
                <i className='bi bi-info-square zocks-text-gray-900 recurring-event-info-square' />
                <span className='paragraph-medium zocks-text-gray-900'>
                  These meetings will remain private and cannot be made public until private meetings are re-enabled
                </span>
              </div>
            </div>
          </Col>
        </Row>
      ) : null}
    </Container>
  )

  return (
    <Modal
      header={<BootstrapModal.Title>Turn off private meetings</BootstrapModal.Title>}
      body={pageBody}
      show={show}
      onHide={onCancel}
      footerPrimaryActionTitle='Apply'
      showFooterActions={true}
      centered
      onFooterPrimaryAction={() => onConfirm(getValues('pastMeetingsAction') === 'change')}
      onFooterSecondaryAction={onCancel}
      headerBodySeparator={true}
    />
  )
}
